module.exports = __webpack_public_path__ + "assets/img/05b3175ae893601cd854e2083139c65e.png";